// This manager coordinates winline animations
musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
musicManager.inBaseGameModifier = false;
musicManager.inBigWin = false;
musicManager.musicLevel = 1;

musicManager.ALLOFFLEVEL = [false, false, false, false];
musicManager.IDLELEVEL = [true, false, false, false];
musicManager.SPINLEVEL = [false, true, false, false];
musicManager.SINGLEWINLEVEL = [false, false, true, false];
musicManager.MULTIWINLEVEL = [false, false, false, true];

musicManager.baseLevels = [musicManager.SPINLEVEL, musicManager.SINGLEWINLEVEL, musicManager.MULTIWINLEVEL];

musicManager.FREESPINS_ALLOFF = [false, false, false];
musicManager.FREESPINS_BASE = [true, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false];
musicManager.FREESPINS_LEVEL2 = [false, false, true];

musicManager.fsLevels = [musicManager.FREESPINS_BASE, musicManager.FREESPINS_LEVEL1, musicManager.FREESPINS_LEVEL2];

// Base
musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.fadeInActive = false;
musicManager.fadeOutActive = false;

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

// Freespins
musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.fadeInActiveFS = false;
musicManager.fadeOutActiveFS = false;

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

musicManager.currentBaseLevels = undefined;
musicManager.currentFSLevels = undefined;

musicManager.returnTimer = undefined;
musicManager.returnDelayTime = 8;

musicManager.returnIdleTimer = undefined;
musicManager.returnIdleTime = 6;

//////////////////////////////////
musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 1000;
  musicManager.fadeBaseTimeOut = 2000;

  musicManager.fadeBigWinTimeIn = 1000;
  musicManager.fadeBigWinTimeOut = 1000;

  musicManager.baseMusic = ['baseTheme0', 'baseTheme1', 'baseTheme2', 'baseTheme3'];

  musicManager.basePlaying = [false, false, false, false];

  musicManager.baseID = [];

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.freeSpinsMusic = ['fsTheme0', 'fsTheme1', 'fsTheme2'];

  musicManager.fsPlaying = [false, false, false];

  musicManager.freeSpinsID = [];
};

//////////////////////////////////
musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(soundManager.play(musicManager.freeSpinsMusic[j]));
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }
  //    soundManager.setVolume( 1, musicManager.baseID[0] );
  //    musicManager.basePlaying[0] = true;

  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

//////////////////////////////////
musicManager.onGameStart = function () {
  musicManager.idle = false;

  if (!musicManager.playing && !musicManager.inFreespins) {
    musicManager.playing = true;

    //soundManager.setVolume( 1, musicManager.baseID[1] );
    // musicManager.basePlaying[1] = true;

    musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

//////////////////////////////////
musicManager.onGameEnd = function () {
  musicManager.idle = true;
  musicManager.playing = false;
  if (!autoplayManager.isAutoplayEnabled() || autoplayManager.getRemainingRounds() <= 0) {
    // idle timer should be 6 seconds according to mikes doc
    // and if we are going back to idle / level 0 then add another 2 seconds
    musicManager.returnIdleTimer = gsap.delayedCall(musicManager.returnIdleTime + 2, () => {
      musicManager.fadeLevels(
        musicManager.IDLELEVEL, //
        musicManager.fadeBaseTimeIn,
        musicManager.fadeBaseTimeOut
      );
    });
  }
};

//////////////////////////////////
musicManager.playBigWin = function (fromShort = false) {
  if (!fromShort) {
    musicManager.bigWinID = soundManager.play('bigWinLoop');
  } else {
    musicManager.bigWinID = soundManager.play('bigWinEnd');
  }

  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF, //
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.ALLOFFLEVEL, //
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  }
};

musicManager.stopBigWin = function () {
  soundManager.stop('bigWinLoop');
};
musicManager.playBigWinEnd = function (fromShort = false) {
  if (!fromShort) {
    soundManager.play('bigWinEnd');
  }
};

//////////////////////////////////
musicManager.endBigWin = function () {
  soundManager.stop('bigWinLoop');
};

musicManager.restoreTunesAfterBigWin = function (level = musicManager.IDLELEVEL) {
  // ideally start the music as it was
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      level, //
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    // go back to the track we had before - but - what if we are then going to the gamble?
    // but we dont know if we are going to the gamble just yet
    // thats all done from 'spinner:GambleDataEvent'
    musicManager.fadeLevels(
      level, //
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut,
      1,
      0
    );
  }
};

//////////////////////////////////
musicManager.fadeBigWin = function (newVolume) {
  soundManager.setVolume(newVolume, musicManager.bigWinID);
};

// Sets a delayed return to lower level
musicManager.tempFadeLevels = function (levels, fadeInTime, fadeOutTime) {
  if (levels == musicManager.currentBaseLevels) {
    if (musicManager.returnTimer) musicManager.returnTimer.restart();
    return;
  }

  let returnIndex = musicManager.baseLevels.indexOf(levels) - 1;
  let returnLevels = returnIndex >= 0 ? musicManager.baseLevels[returnIndex] : undefined;

  musicManager.fadeLevels(levels, fadeInTime, fadeOutTime);

  if (returnLevels) {
    musicManager.returnTimer = gsap.delayedCall(musicManager.returnDelayTime, () => {
      musicManager.tempFadeLevels(returnLevels, fadeInTime, fadeOutTime);
    });
  }
};

// Sets a delayed return to lower level
musicManager.tempFadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  if (levels == musicManager.currentFSLevels) {
    if (musicManager.returnTimer) musicManager.returnTimer.restart();
    return;
  }

  let returnIndex = musicManager.fsLevels.indexOf(levels) - 1;
  let returnLevels = returnIndex >= 0 ? musicManager.fsLevels[returnIndex] : undefined;

  musicManager.fadeFSLevels(levels, fadeInTime, fadeOutTime);

  if (returnLevels) {
    musicManager.returnTimer = gsap.delayedCall(musicManager.returnDelayTime, () => {
      musicManager.tempFadeFSLevels(returnLevels, fadeInTime, fadeOutTime);
    });
  }
};

// Sets a prolong delay to return.
musicManager.restartReturnTimer = function () {
  if (musicManager.returnTimer) musicManager.returnTimer.restart();
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (levels, fadeInTime, fadeOutTime) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here
  musicManager.currentBaseLevels = levels;

  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActive) {
    timerManager.stop(musicManager.fadeInTimer);
    musicManager.fadeLevelsInFinished();
  }

  if (musicManager.fadeOutActive) {
    timerManager.stop(musicManager.fadeOutTimer);
    musicManager.fadeLevelsOutFinished();
  }

  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  musicManager.fadeInActive = false;
  musicManager.fadeOutActive = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
      musicManager.fadeInActive = true;
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
      musicManager.fadeOutActive = true;
    }
  }

  musicManager.fadeInTimer = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsIn,
    musicManager.fadeLevelsInFinished
  );
  musicManager.fadeOutTimer = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOut,
    musicManager.fadeLevelsOutFinished
  );

  musicManager.basePlaying = levels;
};

////////////////////////
musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here

  if (levels == musicManager.currentFSLevels) return;
  musicManager.freeSpinsLevel = levels;
  musicManager.currentFSLevels = levels;

  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActiveFS) {
    timerManager.stop(musicManager.fadeInTimerFS);
    musicManager.fadeLevelsInFinishedFS();
  }

  if (musicManager.fadeOutActiveFS) {
    timerManager.stop(musicManager.fadeOutTimerFS);
    musicManager.fadeLevelsOutFinishedFS();
  }

  // at end as we may not have a channel currently playing - musicManager.fsPlaying = levels;
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  musicManager.fadeInActiveFS = false;
  musicManager.fadeOutActiveFS = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeInActiveFS = true;
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeOutActiveFS = true;
    }
  }

  musicManager.fadeInTimerFS = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsInFS,
    musicManager.fadeLevelsInFinishedFS
  );
  musicManager.fadeOutTimerFS = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOutFS,
    musicManager.fadeLevelsOutFinishedFS
  );

  musicManager.fsPlaying = levels;
};

//////////////////////////////////
// BASE VERSIONS
//////////////////////////////////
musicManager.fadeLevelsIn = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(progress, musicManager.soundsToFadeIn[i]);
  }
};

//////////////////////////////////
musicManager.fadeLevelsOut = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(1 - progress, musicManager.soundsToFadeOut[i]);
  }
};

//////////////////////////////////
musicManager.fadeLevelsInFinished = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(1, musicManager.soundsToFadeIn[i]);
  }

  musicManager.fadeInActive = false;
};

//////////////////////////////////
musicManager.fadeLevelsOutFinished = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(0, musicManager.soundsToFadeOut[i]);
  }

  musicManager.fadeOutActive = false;
};

//////////////////////////////////
// FREESPIN VERSIONS
//////////////////////////////////
musicManager.fadeLevelsInFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(progress, musicManager.soundsToFadeInFS[i]);
  }
};

//////////////////////////////////
musicManager.fadeLevelsOutFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(1 - progress, musicManager.soundsToFadeOutFS[i]);
  }
};

//////////////////////////////////
musicManager.fadeLevelsInFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(1, musicManager.soundsToFadeInFS[i]);
  }

  musicManager.fadeInActiveFS = false;
};

//////////////////////////////////
musicManager.fadeLevelsOutFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(0, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fadeOutActiveFS = false;
};

// //////////////////////////////////
// musicManager.restartBaseMusic = function () {
//   musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
// };

// //////////////////////////////////
// musicManager.restartFreeSpins = function () {
//   musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
// };

//////////////////////////////////
musicManager.onFreespinsIntro = function () {
  // Here we stop the game standard music and freespins music, and play the freespins intro music
  if (!soundManager.isSoundPlaying('GambleLoop')) {
    // stop all base game sounds - should fade off
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);

    soundManager.play('gambleLoop');
    musicManager.playing = false;
  }
};

//////////////////////////////////
musicManager.onFreespinsStart = function () {
  // Here we stop the freespins intro music and play the freespins standard music

  soundManager.stop('gambleLoop');

  //musicManager.resetfreeSpinsLevel();

  musicManager.freeSpinsLevel = musicManager.FREESPINS_BASE;
  musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);

  musicManager.inFreespins = true;
  musicManager.playing = false;
};

//////////////////////////////////
musicManager.freeSpinsNextLevel = function () {
  var changed = false;

  let newLevel;
  if (musicManager.freeSpinsLevel === musicManager.FREESPINS_BASE) {
    newLevel = musicManager.FREESPINS_LEVEL1;
  } else if (musicManager.freeSpinsLevel === musicManager.FREESPINS_LEVEL1) {
    newLevel = musicManager.FREESPINS_LEVEL2;
  } else newLevel = musicManager.freeSpinsLevel;

  musicManager.tempFadeFSLevels(newLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

//////////////////////////////////
musicManager.onFreespinsEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  musicManager.inFreespins = false;

  musicManager.fadeFSLevels(musicManager.FREESPINS_ALLOFF, musicManager.fadeBaseTimeIn, 2000);
  musicManager.fadeLevels(musicManager.IDLELEVEL, 1000, musicManager.fadeBaseTimeOut);
};

//////////////////////////////////
musicManager.onFreespinsLostGambleEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  musicManager.inFreespins = false;

  soundManager.stop('gambleLoop');

  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

//////////////////////////////////
musicManager.setMusicLevel = function (level) {
  musicManager.musicLevel = level;
};

//////////////////////////////////
musicManager.update = function (delta) {
  // Are we playing a sound
  if (musicManager.inFreespins) return;
};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === 'back from replay' && !Reflex.replayGame) {
    musicManager.basePlaying = [false, false, false, false];
    musicManager.baseID = [];
    musicManager.fsPlaying = [false, false, false];
    musicManager.freeSpinsID = [];
    musicManager.onGameLoaded();
    musicManager.fadeLevelsInFinished();
    musicManager.stopAllTimers();
    musicManager.soundsToFadeOut = [];
    musicManager.soundsToFadeIn = [];
    musicManager.soundsToFadeOutFS = [];
    musicManager.soundsToFadeInFS = [];
  }
};

musicManager.stopAllTimers = function () {
  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActive) {
    timerManager.stop(musicManager.fadeInTimer);
    musicManager.fadeInActive = false;
  }

  if (musicManager.fadeOutActive) {
    timerManager.stop(musicManager.fadeOutTimer);
    musicManager.fadeOutActive = false;
  }

  if (musicManager.fadeInActiveFS) {
    timerManager.stop(musicManager.fadeInTimerFS);
    musicManager.fadeInActiveFS = false;
  }

  if (musicManager.fadeOutActiveFS) {
    timerManager.stop(musicManager.fadeOutTimerFS);
    musicManager.fadeOutActiveFS = false;
  }

  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];
};

musicManager.onGoingToReplay = function () {
  const sp = gdk.getServerParser();
  if (sp.replayFromIframeGame === false) {
    musicManager.stopAllTimers();
  }
};

//////////////////////////////////
Reflex.addToUpdate(musicManager.update);
Reflex.registerInitialiseManager(musicManager.initialise);
messageBus.subscribe('sounds:restorePreviouslyPlayingAudio', musicManager.onRestorePreviouslyPlayingAudio);
messageBus.subscribe('game:goingToReplay', musicManager.onGoingToReplay);
